module.exports = __webpack_public_path__ + "c189255f257287765b4552d0a70b0d08.svg";